import type { CSSProperties, MouseEvent, ReactNode } from "react";

import { classNames } from "helpers/commonHelpers";

const INTERACTIVE_SELECTOR =
  "input, select, textarea, button, label, [role='combobox'], .cb-select__control, .cb-select__menu";

export function handleCellPaddingClick(event: MouseEvent<HTMLDivElement>) {
  const target = event.target as HTMLElement;
  if (target.closest(INTERACTIVE_SELECTOR)) return;

  let container: Element;
  if (target === event.currentTarget) {
    container = event.currentTarget;
  } else {
    const children = Array.from(event.currentTarget.children);
    container = children.find((child) => child.contains(target)) ?? event.currentTarget;
  }

  const checkbox = container.querySelector<HTMLInputElement>("input[type='checkbox']");
  if (checkbox) {
    checkbox.click();
    return;
  }

  const selectControl = container.querySelector<HTMLElement>(".cb-select__control");
  if (selectControl) {
    selectControl.dispatchEvent(new MouseEvent("mousedown", { bubbles: true, cancelable: true }));
    return;
  }

  const input = container.querySelector<HTMLInputElement>("input:not([type='checkbox']):not([type='hidden'])");
  if (input) {
    input.focus();
  }
}

type PackingListCellProps = {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
};

export default function PackingListCell({ children, className, style }: PackingListCellProps) {
  return (
    <div className={classNames("rfv2-packing-list-table__cell", className ?? "")} style={style} onClick={handleCellPaddingClick}>
      {children}
    </div>
  );
}
